import {
  Component,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
  ComponentRef,
  EventEmitter,
  Output,
  HostListener,
  OnInit,
  OnDestroy
} from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';

@Component({
    selector: 'modal',
    templateUrl: './modal.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
/**
 * API to an open modal window.
 */
export class ModalComponent implements OnInit, OnDestroy {
  /**
   * Caption for the title.
   */
  public modalTitle: string;
  public hasClassModal = false;
  /**
   * component which is to be loaded dynamically.
   */
  public component: any;
  /**
   * Describes if the modal contains Ok Button.
   * The default Ok button will close the modal and emit the callback.
   * Defaults to true.
   */
  public okButton = true;
  /**
   * Caption for the OK button.
   * Default: Ok
   */
  public okButtonText = 'Ok';
  /**
   * Describes if the modal contains cancel Button.
   * The default Cancelbutton will close the modal.
   * Defaults to true.
   */
  public cancelButton = true;
  public closeButton = true;
  /**
   * Caption for the Cancel button.
   * Default: Cancel
   */
  public cancelButtonText = 'Cancel';
  /**
   * if the modalMessage is true it will show the message inside modal body.
   */
  public modalMessage = true;
  /**
   * Some message/content can be set in message which will be shown in modal body.
   */
  public message: string;
  /**
   * if the value is true modal footer will be visible or else it will be hidden.
   */
  public modalFooter = true;
  /**
   * shows modal header if the value is true.
   */
  public modalHeader = true;
  /**
   * if the value is true modal will be visible or else it will be hidden.
   */
  public isOpen = false;
  /**
   * component to check the type
   */
  public componentToCheck: any;

  /**
   * component to check the type
   */
  subscription: Subscription;
  keyDowns: Observable<KeyboardEvent>;
  /**
   * Emitted when a ok button was clicked
   * or when close method is called.
   */
  cmpRef: ComponentRef<any>;
  // @ViewChild(OpenDirective) componentDirective: OpenDirective;
  @ViewChild('child', { read: ViewContainerRef, static: true }) target: ViewContainerRef;
  @Output() public modalOutput: EventEmitter<any> = new EventEmitter();
  @Output() public modalClosed: EventEmitter<any> = new EventEmitter();
  constructor(public componentFactoryResolver: ComponentFactoryResolver, public viewContainer: ViewContainerRef) {}
  /**
   * Opens a modal window creating backdrop.
   * @param component The angular Component that is to be loaded dynamically(optional).
   */
  ngOnInit() {
    this.keyDowns = fromEvent(document, 'keydown').pipe(
      filter((e: KeyboardEvent) => e.key === 'Escape'),
      distinctUntilChanged()
    );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  open(component?: any, data?: any) {
    this.isOpen = true;
    if (this.cmpRef) {
      this.cmpRef.destroy();
    }
    if (component) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
      this.cmpRef = this.target.createComponent(componentFactory);
      this.componentToCheck = this.cmpRef.instance;
      if (data) {
        this.cmpRef.instance.init(data);
      }
    }
    this.subscription = this.keyDowns.subscribe((escpress) => {
      if (escpress.type === 'keydown') {
        this.close();
      }
    });
  }
  /**
   *  close method dispose the component, closes the modal and optionally emits modalOutput value.
   */
  close(data?: any) {
    this.dispose();
    if (data) {
      this.modalOutput.emit(data);
    } else if (this.modalClosed) {
      this.modalClosed.emit(null);
    }
  }
  /**
   *  close method dispose the component, closes modal on outside click if it is menu component.
   */
  closeOnOutsideClick(e?: Event) {
    if (e && (<HTMLElement>e.target).id === 'myModal') {
      this.close();
    }
    /*if (this.componentToCheck && this.componentToCheck.mustCloseOnOutsideClick) {
      this.close();
    }*/
  }
  /**
   *  ok method dispose the component, closes the modal and emits true.
   */
  submit() {
    this.dispose();
    this.modalOutput.emit(true);
  }
  /**
   *  dispose method dispose the loaded component.
   */
  dispose() {
    this.isOpen = false;
    if (this.component !== undefined) {
      this.component.then((componentRef: ComponentRef<any>) => {
        componentRef.destroy();
        return componentRef;
      });
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
